import withBaseUrl from "@/Utils/const";
import Head from "next/head";

const MetaTags = ({
  title = "Qoncert - Your Ultimate Concert Experience",
  description = "Find and book tickets for the best concerts and live music events. Qoncert offers a seamless experience for music lovers.",
  ogImage = withBaseUrl("/assets/logo.webp"),
  canonicalUrl,
  keywords = "concerts, live music, tickets, events, music festivals",
  author = "Qoncert",
  noindex = false,
  ogType = "website",
  showData = null,
}) => {
  const fullCanonicalUrl = withBaseUrl(canonicalUrl);

  const showTitle = showData?.name ? `${showData.name} | Qoncert` : title;
  const showDescription = showData?.description || description;
  const showImage = showData?.banner || ogImage;
  const showType = showData ? "event" : ogType;

  const formatDate = (date) => {
    try {
      return new Date(date).toISOString();
    } catch (e) {
      return null;
    }
  };

  const getEventStatus = (showDate) => {
    if (!showDate) return null;
    const now = new Date();
    const eventDate = new Date(showDate);
    return eventDate > now ? "upcoming" : "past";
  };

  return (
    <Head>
      <title>{showTitle}</title>
      <meta name="description" content={showDescription} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />

      {noindex ? (
        <meta name="robots" content="index,follow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}

      <meta property="og:title" content={showTitle} />
      <meta property="og:description" content={showDescription} />
      <meta property="og:image" content={showImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content={showType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:site_name" content="Qoncert" />

      {showData && (
        <>
          <meta
            property="og:event:start_time"
            content={formatDate(showData.show_at)}
          />
          <meta
            property="og:event:end_time"
            content={formatDate(showData.show_ends_at)}
          />
          <meta
            property="og:event:location"
            content={`${showData.venue?.name}, ${showData.venue?.city}, ${showData.venue?.state}`}
          />
          <meta
            property="og:event:status"
            content={getEventStatus(showData.show_at)}
          />
          <meta property="og:event:category" content="Concert" />
          {showData.price && (
            <>
              <meta property="og:price:amount" content={showData.price} />
              <meta property="og:price:currency" content="USD" />
            </>
          )}
          <meta
            property="og:availability"
            content={showData.is_ticket_booked ? "sold_out" : "in_stock"}
          />
        </>
      )}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@qoncert" />
      <meta name="twitter:title" content={showTitle} />
      <meta name="twitter:description" content={showDescription} />
      <meta name="twitter:image" content={showImage} />

      <link rel="canonical" href={fullCanonicalUrl} />

      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="theme-color" content="#000000" />
    </Head>
  );
};

export default MetaTags;
